import {useCallback, useRef, useState} from 'react';
import {Drawer, DrawerMode, useDrawerMode} from '@esgi/main/features/teacher/home';
import {StudentProfile} from './components/student-profile';
import {StudentProfileMode} from './components/student-profile/types';
import {ModalOwnerContainer} from './index.styled';
import {useSearchParams} from 'react-router-dom';
import {UnsavedChangesAlert} from './components/student-profile/components/unsaved-changes-alert';

export * from './events';

export const StudentProfileDrawerName = 'teacherStudentViaProfile';

export function StudentProfileDrawer() {
	const [searchParams] = useSearchParams();
	const drawerMode = useDrawerMode({
		drawerName: StudentProfileDrawerName,
	});
	const studentDrawerModalsOwner = useRef();
	const mode =
		drawerMode === DrawerMode.Create
			? StudentProfileMode.add
			: StudentProfileMode.edit;
	const name = searchParams.get('drawerName');
	const isOpen = name === StudentProfileDrawerName;

	const [isUnsavedChangesAlert, setUnsavedChangesAlert] = useState(false);

	const formTouchedRef = useRef<{
		updateTouchedStatus: () => boolean;
		isInitialized: boolean;
	}>();

	const onBeforeCloseDrawerCb = useCallback(() => {
		const isFormTouched = formTouchedRef.current.updateTouchedStatus();
		const isInitialized = formTouchedRef.current.isInitialized;

		if (isFormTouched && isInitialized) {
			setUnsavedChangesAlert(true);
		}

		return !(isFormTouched && isInitialized);
	}, [formTouchedRef]);

	return (
		<>
			<Drawer
				drawerName={StudentProfileDrawerName}
				beforeCloseDrawerCb={onBeforeCloseDrawerCb}
				dataCy='drawer-with-student-via-profile'
			>
				{isOpen && (
					<StudentProfile
						mode={mode}
						modalsOwner={studentDrawerModalsOwner}
						formTouchedRef={formTouchedRef}
					/>
				)}
				{isUnsavedChangesAlert && (
					<UnsavedChangesAlert onClose={() => setUnsavedChangesAlert(false)} />
				)}

			</Drawer>
			<ModalOwnerContainer ref={studentDrawerModalsOwner} />
		</>
	);
}
